import { dayKey, hhmmOf } from "../cabinet/index.js";

/**
 * Чистые функции недельной сетки (`WeekGrid`): положение момента в дне по настенному времени салона
 * и раскладка пересекающихся блоков. Без React, чтобы проверять в Vitest.
 */

/**
 * Минуты от местной полуночи дня `k` по настенному времени в поясе `tz`: запись на 10:00 стоит в строке 10:00
 * и в день перехода на зимнее или летнее время (миллисекунды от полуночи в такой день дали бы сдвиг на час).
 * Момент раньше дня: -1; позже: 24 * 60.
 */
export function minutesIntoDay(k: string, at: Date, tz: string): number {
  const d = dayKey(at, tz);
  if (d < k) return -1;
  if (d > k) return 24 * 60;
  const [h = 0, m = 0] = hhmmOf(at, tz).split(":").map(Number);
  return h * 60 + m;
}

export interface Placed<T> {
  item: T;
  /** Доля ширины колонки слева и ширина (0..1): пересекающиеся записи разных мастеров встают рядом. */
  left: number;
  width: number;
}

/** Раскладка пересекающихся интервалов по дорожкам: группа взаимно пересекающихся блоков делит ширину поровну. */
export function placeOverlaps<T extends { start: Date; end: Date }>(items: T[]): Placed<T>[] {
  const sorted = [...items].sort((a, b) => a.start.getTime() - b.start.getTime() || a.end.getTime() - b.end.getTime());
  const out: Placed<T>[] = [];
  let group: { item: T; lane: number }[] = [];
  let laneEnds: number[] = [];
  let groupEnd = 0;
  const flush = () => {
    const lanes = laneEnds.length || 1;
    for (const g of group) out.push({ item: g.item, left: g.lane / lanes, width: 1 / lanes });
    group = [];
    laneEnds = [];
  };
  for (const item of sorted) {
    const start = item.start.getTime();
    if (group.length > 0 && start >= groupEnd) flush();
    let lane = laneEnds.findIndex((end) => end <= start);
    if (lane === -1) {
      lane = laneEnds.length;
      laneEnds.push(0);
    }
    laneEnds[lane] = item.end.getTime();
    group.push({ item, lane });
    groupEnd = Math.max(groupEnd, item.end.getTime());
  }
  flush();
  return out;
}
